import React from 'react'
import { EVENT } from '@classy/campaign-page-blocks'
import type { PageConfig } from 'models/pages'
import { buildMParticleGlobalProperties, useInternalAnalytics } from '.'

export interface ValueSelectedEventPayload {
  value: string
  trackingId: string
}

export const useMParticleEventListeners = (pageConfig: PageConfig, loggedInState: boolean) => {
  const { mParticle, consentSynced } = useInternalAnalytics()

  // * Listen for `Value Selected` custom event
  React.useEffect(() => {
    document.addEventListener(EVENT.ANALYTICS_VALUE_SELECTED, (e) => {
      const { detail } = e as CustomEvent<ValueSelectedEventPayload>
      if (!mParticle || !consentSynced || !detail) return

      const globalProperties = buildMParticleGlobalProperties(mParticle, loggedInState)

      mParticle.logEvent(
        'Value Selected',
        mParticle.EventType.Other,
        {
          campaign_id: pageConfig.campaignId,
          npo_id: pageConfig.orgId,
          npo_name: pageConfig.orgName,
          value: detail.value,
          tracking_id: detail.trackingId,
          ...globalProperties,
        },
        {
          'GA4.Title': document.title,
          'GA4.Location': document.location.href,
          'GA4.Referrer': document.referrer,
        },
      )
    })

    return () => {
      document.removeEventListener(EVENT.ANALYTICS_VALUE_SELECTED, () => {})
    }
  }, [mParticle, consentSynced, pageConfig, loggedInState])
}
